import Vue from 'vue';
import VueQR from 'vue-qriously';
import TextareaAutosize from 'vue-textarea-autosize';

// BUEFY
import Buefy from 'buefy';
import SocialSharing from 'vue-social-sharing'

// Atoms
import EdlButton from '~/components/atoms/EdlButton'
import EdlTag from '~/components/atoms/EdlTag'

// Components
import SpinnerLoading from '~/components/SpinnerLoading';
import EmptyData from '~/components/EmptyData';
import Pagination from '~/components/Pagination';
import Avatar from '~/components/Avatar';
import IconCollection from '~/components/IconCollection';
import VerifyCodeInput from '~/components/VerifyCodeInput';
import BackButton from '~/components/BackButton';
import ClassBox from '~/components/ClassBox';
import FollowedGroupBox from '~/components/FollowedGroupBox';
import WeekScheduleBox from '~/components/WeekScheduleBox';
import Setup from '~/components/Setup';
import ClassFilter from '~/components/ClassFilter';
import GroupFilter from '~/components/GroupFilter';
import MediaFilter from '~/components/MediaFilter';
import MediaFilterGoogleDrive from '~/components/MediaFilterGoogleDrive';
import UserFilter from '~/components/UserFilter';
import UniversityFilter from '~/components/UniversityFilter';
import SectionsBox from '~/components/SectionsBox';
import UploadTeacherQuestionAnswerBoxStudent from '~/components/UploadTeacherQuestionAnswerBoxStudent';
import PostStats from '~/components/PostStats';
import UserStats from '~/components/UserStats';
import Youtube from '~/components/Youtube';
import ShortIcon from '~/components/ShortIcon';
import UniversityNewsBox from '~/components/UniversityNewsBox';

// MOLECULES
import List from '~/components/molecules/List';
import EdlAlert from '~/components/molecules/EdlAlert'
// Messages
import MessageInput from '~/components/molecules/messages/MessageInput';
import Messages from '~/components/molecules/messages/Messages';
import MessageRoom from '~/components/molecules/messages/Room';
import MessageRoomItem from '~/components/molecules/messages/RoomItem';
import MessageRoomTitle from '~/components/molecules/messages/RoomTitle';
import Contacts from '~/components/molecules/messages/Contacts';
import CollapseToggler from '~/components/molecules/CollapseToggler';

// Container
import MediaLibrary from '~/components/containers/MediaLibrary';
import MediaLibraryModal from '~/components/containers/modals/MediaLibraryModal';
import ResultQuizModal from '~/components/containers/modals/ResultQuizModal';
import KhsModal from '~/components/containers/modals/KhsModal';
import KrsModal from '~/components/containers/modals/KrsModal';
import TranscriptModal from '~/components/containers/modals/TranscriptModal';
import GradeModal from '~/components/containers/modals/GradeModal';
import GuidanceModal from '~/components/containers/modals/GuidanceModal';
import PostLists from '~/components/containers/PostLists';
import TimelineLists from '~/components/containers/TimelineLists';
import QuizRank from '~/components/containers/learning_materials/QuizRank';
import TeacherQuestionAnswererLists from '~/components/containers/learning_materials/TeacherQuestionAnswererLists';
import PreviewModal from '~/components/containers/modals/PreviewModal';
import UniversityNewsModal from '~/components/containers/modals/UniversityNewsModal';

// FORMS
import GroupSelection from '~/components/forms/GroupSelection';
import SectionSelection from '~/components/forms/SectionSelection';

// GROUPS
import InfoBox from '~/components/groups/InfoBox';
import GroupMembersBox from '~/components/groups/GroupMembersBox';
import GroupSchedules from '~/components/groups/GroupSchedules';
import GroupFiles from '~/components/groups/GroupFiles';

// EDLODERS
import EdlordersWaitingPayment from '~/components/edlorders/EdlordersWaitingPayment'
import EdlordersBuy from '~/components/edlorders/EdlordersBuy'

// Bind Library
// Vue.use(Notif);
Vue.use(VueQR);
Vue.use(TextareaAutosize);

// REGISTER BUEFY
Vue.use(Buefy);

// REGISTER SOCIAL BUTTON
Vue.use(SocialSharing)

// Registered Components
Vue.component('spinner-loading', SpinnerLoading);
Vue.component('media-library', MediaLibrary);
Vue.component('media-library-modal', MediaLibraryModal);
Vue.component('pagination', Pagination);
Vue.component('avatar', Avatar);
Vue.component('group-selection', GroupSelection);
Vue.component('result-quiz-modal', ResultQuizModal);
Vue.component('post-lists', PostLists);
Vue.component('timeline-lists', TimelineLists);
Vue.component('khs-modal', KhsModal);
Vue.component('krs-modal', KrsModal);
Vue.component('transcript-modal', TranscriptModal);
Vue.component('grade-modal', GradeModal);
Vue.component('guidance-modal', GuidanceModal);
Vue.component('icon-collection', IconCollection);
Vue.component('verify-code-input', VerifyCodeInput);
Vue.component('back-button', BackButton);
Vue.component('class-box', ClassBox);
Vue.component('followed-group-box', FollowedGroupBox);
Vue.component('week-schedule-box', WeekScheduleBox);
Vue.component('info-box', InfoBox);
Vue.component('group-members-box', GroupMembersBox);
Vue.component('group-schedules', GroupSchedules);
Vue.component('group-files', GroupFiles);
Vue.component('setup', Setup);
Vue.component('class-filter', ClassFilter);
Vue.component('group-filter', GroupFilter);
Vue.component('media-filter', MediaFilter);
Vue.component('media-filter-google-drive', MediaFilterGoogleDrive);
Vue.component('user-filter', UserFilter);
Vue.component('university-filter', UniversityFilter);
Vue.component('sections-box', SectionsBox);
Vue.component('section-selection', SectionSelection);
Vue.component('quiz-rank', QuizRank);
Vue.component('teacher-question-answerer-lists', TeacherQuestionAnswererLists);
Vue.component('upload-tqa-box-student', UploadTeacherQuestionAnswerBoxStudent);
Vue.component('preview-modal', PreviewModal);
Vue.component('post-stats', PostStats);
Vue.component('user-stats', UserStats);
Vue.component('youtube', Youtube);
Vue.component('list', List);
Vue.component('shorticon', ShortIcon);
Vue.component('university-news-modal', UniversityNewsModal);
Vue.component('university-news-box', UniversityNewsBox);
Vue.component('message-input', MessageInput);
Vue.component('messages', Messages);
Vue.component('message-room', MessageRoom);
Vue.component('message-room-item', MessageRoomItem);
Vue.component('message-room-title', MessageRoomTitle);
Vue.component('contacts', Contacts);
Vue.component('collapse-toggler', CollapseToggler);
Vue.component('empty-data', EmptyData);
Vue.component('edlorders-buy', EdlordersBuy)
Vue.component('edloders-waiting-payment', EdlordersWaitingPayment)
Vue.component('edl-button', EdlButton)
Vue.component('edl-tag', EdlTag)
Vue.component('edl-alert', EdlAlert)

if (process.browser) {
  const Carousel = require('vue-carousel').default;
  const CustomCarousel = require('~/components/CustomCarousel').default;

  Vue.use(Carousel);

  Vue.component('custom-carousel', CustomCarousel);
}
